import { cn } from "@/lib/utils";

interface QualityBadgeProps {
  rating: number;
  size?: "sm" | "lg";
}

const getQualityColor = (rating: number) => {
  if (rating >= 3.6) return "bg-green-600 text-white";
  if (rating >= 2.5) return "bg-yellow-500 text-white";
  return "bg-red-600 text-white";
};

const getQualityLabel = (rating: number) => {
  if (rating >= 4.5) return "Awesome";
  if (rating >= 4) return "Great";
  if (rating >= 3) return "Good";
  if (rating >= 2) return "OK";
  return "Awful";
};

const QualityBadge = ({ rating, size = "sm" }: QualityBadgeProps) => {
  return (
    <div className="flex flex-col items-center gap-0.5">
      <div
        className={cn(
          "flex items-center justify-center rounded-xl font-bold shadow-sm",
          getQualityColor(rating),
          size === "lg" ? "w-16 h-16 text-2xl" : "w-11 h-11 text-lg"
        )}
      >
        {rating.toFixed(1)}
      </div>
      <span className={cn(
        "font-medium text-muted-foreground",
        size === "lg" ? "text-xs" : "text-[10px]"
      )}>
        {getQualityLabel(rating)}
      </span>
    </div>
  );
};

export default QualityBadge;
